import Wrapper from '../components/global/Wrapper';

import { Benefits, SupportSection } from '../components/BusinessDashboard';
import axios, { AxiosError } from 'axios';
import { baseUrl_, timeout } from '../utils/constants';
import { useQuery } from 'react-query';
import { decryptJson } from '../utils/decryptJson';
import { useEffect, useState } from 'react';
import { TRegistration, TServiceCharge } from '../types';
import { ClipLoader } from 'react-spinners';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setAllPackages } from '../features/packages/packagesSlice';
import { logUserOut } from '../utils/logUserOut';
import { fetchPackages, getEntrepreneur } from '../utils/getPackageName';
import { useLocation } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { registerNetcoreActivity } from '../utils/registerActivity';
import ReactGA from 'react-ga4';

const BusinessPage = () => {
  const benefits = [
    'Free Banking for up to three years',
    'Zero charges on search report for account opening.',
    'Business advisory from our team of experts.',
  ];
  const queryParam = Number(useLocation()?.search?.replace('?active=', '') ?? '1');
  const token: any = localStorage.getItem('login-token');
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState<TServiceCharge[]>([]);
  const [registrations, setRegistrations] = useState<TRegistration[]>([]);
  const [selectedTab, setSelectedTab] = useState(queryParam);

  const dispatch = useAppDispatch();
  const allPackagesAndPrice = useAppSelector((state) => state.packages?.packages);

  const fetchingEntrepreneur = useQuery('entrepreneur', getEntrepreneur, {
    onSuccess: (data) => {
      const res = decryptJson(data?.data?.data);
      if (Array.isArray(res)) {
        setRegistrations(res);
      } else {
        setRegistrations([res]);
      }
    },
    onError: (error: AxiosError<{ message: string; status?: number }>) => {
      // handleError({ error, errorFn });
      if (error?.response?.data?.status === 593) {
        logUserOut(error?.response?.data?.status);
      } else {
        setError(error?.response?.data?.message ?? '');
      }
    },
  });

  useEffect(() => {
    if (allPackagesAndPrice?.length === 0) {
      setLoading(true);
      fetchPackages()
        .then((data) => {
          const res = decryptJson(data?.data?.data);
          setPackages(res);
          dispatch(setAllPackages(res));
          setLoading(false);
        })
        .catch((error: AxiosError<{ message: string; status?: number }>) => {
          if (error?.response?.data?.status === 593) {
            logUserOut(error?.response?.data?.status);
          } else {
            setLoading(false);
            setError(error.response?.data?.message ?? '');
          }
        });
    }
  }, [allPackagesAndPrice]);

  useEffect(() => {
    registerNetcoreActivity(
      {
        emailAddress: details?.email,
        firstName: details?.firstName,
        lastName: details?.lastName,
        mobileNumber: details?.phoneNumber,
      },
      'TBH_BUSINESS_REGISTRATION_STEP_1',
    );

    ReactGA.event({
      category: 'Button',
      action: 'TBH_BUSINESS_REGISTRATION_STEP_1',
      label: 'TBH_BUSINESS_REGISTRATION_STEP_1',
      // value: 1
    });
  }, []);

  return (
    <>
      <Wrapper className='h-[100%] space-y-3 pt-[12px]  md:space-y-8  !mr-0'>
        {error ? (
          <div className='flex justify-center'>
            <b className='text-[red] text-[14px]'>{error}</b>
          </div>
        ) : (
          !error &&
          (loading ? (
            //  || fetchingEntrepreneur?.isLoading
            <div className='flex justify-center items-center h-[600px]'>
              <ClipLoader
                color={'#F8B400'}
                loading={
                  loading
                  // || fetchingEntrepreneur?.isLoading
                }
                size={50}
              />
            </div>
          ) : (
            <div className='sl:flex sl:flex-row'>
              <Benefits label={'Benefit'} benefits={benefits} />
              <SupportSection
                packages={Object.keys(packages)?.length ? packages : allPackagesAndPrice}
                registrations={registrations}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                loadingRegistrations={fetchingEntrepreneur?.isLoading}
              />
            </div>
          ))
        )}
      </Wrapper>
    </>
  );
};

export default BusinessPage;
